import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import React, { useState } from "react";
import PhoneNumber from "../../components/PhoneNumber";
import Text from "../../components/Text";
import SelectFromList from "../../components/SelectFromList";
import Lang from "../../components/Lang";
import ChooseDate from "../../components/ChooseDate";
import mut from "../../hooks/mut";
import DatePicker from "../../components/DatePicker";
import AddButton from "../../components/AddButton";

export default function NewTestDialog(props) {
    const { open, setOpen,setContacts } = props;
    const [contact, setContact] = useState({
        phone: "",
        name: "",
        notes: "",
        location: "",
        testDate: new Date(),
        students:[{name:"",dateOfBirth:"",grade:""}],
    })

    const add = async () => {
        let result = await mut("post", "/add-marketing-number", contact)
        if (result && result.success) {
            setContacts(prev => [...prev, result.newContact])
            setContact({
              phone: "",
              name: "",
              notes: "",
              location: "",
              testDate: new Date(),
              students: [{ name: "", dateOfBirth: "", grade: "" }],
            });
            setOpen(false)
        }
    }

    const choices = [
      {
        _id: "Referred by another parent",
        name: <Lang w="referredByAnotherParent" />,
      },
      {
        _id: "Relation of existing student",
        name: <Lang w="relationOfExistingStudent" />,
      },
      {
        _id: "Student who was a lead or stopped",
        name: <Lang w="studentWhoWasALeadOrStopped" />,
      },
      {
        _id: "Came into the center themselves",
        name: <Lang w="cameIntoTheCenterThemselves" />,
      },
      {
        _id: "Marketing online",
        name: <Lang w="marketingOnline" />,
      },

      {
        _id: "Marketing offline",
        name: <Lang w="marketingOffline" />,
      },
      {
        _id: "Resales",
        name: <Lang w="resales" />,
      },
      {
        _id: "Other reason",
        name: <Lang w="otherReason" />,
      },
    ];

  return (
    <Dialog
      open={open}
      fullWidth
    >
      <DialogTitle>
        <Lang w="addANewTest" />
      </DialogTitle>
      <DialogContent
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 15,
          paddingTop: 10,
        }}
      >
        <PhoneNumber
          value={contact.phone}
          setValue={(phone) => {
            setContact((prev) => ({ ...prev, phone }));
          }}
          label="Phone"
        />

        <Text
          value={contact.name}
          setValue={(name) => {
            setContact((prev) => ({ ...prev, name }));
          }}
          label="Name"
        />
        <Text
          value={contact.notes}
          setValue={(notes) => {
            setContact((prev) => ({ ...prev, notes }));
          }}
          label="Notes"
          multiline
          rows={2}
          style={{ fontSize: 14 }}
        />
        <SelectFromList
          choices={choices}
          value={contact.location}
          setValue={(location) => {
            setContact((prev) => ({ ...prev, location }));
          }}
          label={<Lang w="whereAreTheyFrom?" />}
        />
        <ChooseDate
          label="Date of test"
          value={contact.testDate}
          setValue={(testDate) => {
            setContact((prev) => ({ ...prev, testDate }));
          }}
        />
        <div>
          <Lang w="students" />
        </div>
        {contact.students.map((student, index) => (
          <DrawStudent
            student={student}
            key={index}
            index={index}
            setContacts={setContacts}
            contact={contact}
          />
        ))}
        <AddButton action={() => {
          contact.students.push({ name: "", dateOfBirth: "", grade: "" })
          setContacts(prev=>prev.map(p=>p._id===contact._id?contact:p))
        }} />
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
        <Button
          color="success"
          onClick={add}
          {...((contact.name === "" ||
            contact.phone === "" ||
            contact.notes === "" ||
            contact.location === "") && {
            disabled: true,
          })}
        >
          Go
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function DrawStudent({ student,setContacts, index,contact }) {

  const update = (u) => {
    student[u.field] = u.value;
    contact.students[index] = student;
      setContacts((prev) => prev.map((p) => (p._id === contact._id ? contact : p)));
    }

    return (
      <div>
        <div style={{ display: "flex", gap: 5 }}>
          <Text
            value={student.name}
            setValue={(name) => update({ field: "name", value: name })}
            label="Name"
            size="small"
            style={{ flexGrow: 1 }}
          />
          <DatePicker
            value={student.dateOfBirth}
            label={<Lang w="dateOfBirth" />}
            setValue={(dateOfBirth) =>
              update({ field: "dateOfBirth", value: dateOfBirth })
            }
          />
          <Text
            value={student.grade}
            type="number"
            label={<Lang w="grade" />}
            size="small"
            style={{ width: 100 }}
            setValue={(grade) => update({ field: "grade", value: grade })}
          />
        </div>
      </div>
    );
}